/**
 * Authentication utilities for localStorage management
 */

/**
 * Get stored authentication from localStorage
 */
export function getStoredAuth() {
  try {
    const token = localStorage.getItem('tms_token');
    const userStr = localStorage.getItem('tms_user');
    const user = userStr ? JSON.parse(userStr) : null;
    return token && user ? { token, user } : null;
  } catch {
    return null;
  }
}

/**
 * Store authentication to localStorage
 */
export function setStoredAuth(token, user) {
  try {
    localStorage.setItem('tms_token', token);
    localStorage.setItem('tms_user', JSON.stringify(user));
  } catch {}
}

/**
 * Clear authentication from localStorage
 */
export function clearStoredAuth() {
  try {
    localStorage.removeItem('tms_token');
    localStorage.removeItem('tms_user');
  } catch {}
}
